import { useState, useCallback, useRef, useEffect } from "react"

interface CursorPagination {
  after: string | null | undefined
  first: number
  page: number
  goNext: (endCursor: string) => void
  goPrev: () => void
  reset: () => void
  canGoPrev: boolean
}

export function useCursorPagination(pageSize: number, deps: unknown[] = []): CursorPagination {
  const [cursorStack, setCursorStack] = useState<string[]>([])
  const depsRef = useRef(deps)

  useEffect(() => {
    const changed = deps.some((d, i) => d !== depsRef.current[i])
    if (changed) {
      depsRef.current = deps
      setCursorStack([])
    }
  }, deps) // eslint-disable-line react-hooks/exhaustive-deps

  const after = cursorStack.length > 0 ? cursorStack[cursorStack.length - 1] : null

  const goNext = useCallback((endCursor: string) => {
    setCursorStack((prev) => [...prev, endCursor])
  }, [])

  const goPrev = useCallback(() => {
    setCursorStack((prev) => prev.slice(0, -1))
  }, [])

  const reset = useCallback(() => {
    setCursorStack([])
  }, [])

  return {
    after,
    first: pageSize,
    page: cursorStack.length + 1,
    goNext,
    goPrev,
    reset,
    canGoPrev: cursorStack.length > 0,
  }
}
